import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"

const useSetting = (key, order = "desc") => {
  const [settingData, setSettingData] = useState([])
  const {
    data: settingDataResponse,
    isLoading,
    isError,
    isFetching,
  } = useCustomQuery(
    [`settings-${key}`],
    `settings?filter[key]=${key}&sort_order=${order}`
  )

  useEffect(() => {
    if (settingDataResponse?.data) {
      setSettingData(settingDataResponse.data)
    }
  }, [settingDataResponse])
  return {
    settingData,
    isLoading,
    isError,
    isFetching,
    setSettingData,
  }
}

export default useSetting
